<template>
    <div class="progress-bar">
        <div ref="bar" class="bar" v-bind:style="{ 'width': `${progress}%` }"></div>
        <small>{{ progress }}%</small>
    </div>
</template>
<script>
export default {
    name: 'progress-bar',
    props: {
        progress: {
            type: Number,
            required: true,
            default: 0
        }
    },
    data () {
        return {

        }
    }
}
</script>
<style lang="scss" scoped>
@import "@/assets/scss/_variables.scss";

.progress-bar {
    position: relative;
    width: 100%;
    background-color: $gray-200;
    border: 1px solid $gray-400;
    .bar {
        transition: width .2s;
        width: 1%;
        height: 18px;
        background-color: rgba(40, 167, 69, .5);
    }
    small {
        color: #444444;
        display: block;
        font-weight: 600;
        text-align: center;
        position: absolute;
        width: 100%;
    }
}
</style>
